export default "__VITE_ASSET__DXLHmtHB__"